import { render, staticRenderFns } from "./Provinsi.vue?vue&type=template&id=14b75586&"
import script from "./Provinsi.vue?vue&type=script&lang=js&"
export * from "./Provinsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports